AOS.init();

window.floatingHeaderLock = false;
$(window).on(
    'scroll',
    function () {
        if ($(window).scrollTop() > 0) {
            $('body').addClass('is-scrolling');
            $('.site-header').addClass('site-header--sticked-top');
        } else {
            $('body').removeClass('is-scrolling');
            $('.site-header').removeClass('site-header--sticked-top');
        }
    }
).on(
    'load',
    function () {
        var $window = $(window);
        $window.on('scroll', function () {
            handleStickyHeader();
        });
    }
);
handleStickyHeader();
var headerHeight = $('.site-header').height() + 20;
var lastScrollTop = 0;

function handleStickyHeader() {
    if (window.floatingHeaderLock) {
        return;
    }

    var currentScrollTop = $(window).scrollTop();

    if (currentScrollTop - headerHeight <= 0) {
        $('body').removeClass('is-scrolling-down is-scrolling-up');
    } else if (currentScrollTop > lastScrollTop) {
        $('body').removeClass('is-scrolling-up');
        $('body').addClass('is-scrolling-down');
    } else {
        $('body').removeClass('is-scrolling-down');
        $('body').addClass('is-scrolling-up');
    }

    lastScrollTop = currentScrollTop;
}

function lockFloatingHeader() {
    window.floatingHeaderLock = true;

    setTimeout(function () {
        window.floatingHeaderLock = false;
    }, 3000);
}

// Site Navigation Overflow Stopped on Navbar Toggle
$('#siteNavigation').on('show.bs.collapse', function () {
    $('body').addClass('overflow-stopped menu-shown');
}).on('hide.bs.collapse', function () {
    $('body').removeClass('overflow-stopped menu-shown');
})


$('.site-navigation .dropdown .dropdown-menu').on("click.bs.dropdown", function (e) {
    e.stopPropagation();
    // e.preventDefault();
});

$('.accordion-card .accordion-card__title').on('click', function (e) {
    if ($(this).hasClass('active')) {
        $('.accordion-card__title').removeClass('active');
        $('.accordion-card .accordion-card__content').slideUp();
    } else {
        $('.accordion-card__title').removeClass('active');
        $(this).addClass('active');
        $('.accordion-card .accordion-card__content').slideUp();
        $(this).parent().find('.accordion-card__content').slideDown();
    }
});

$('.dropdown-menu .dropdown-toggler').on('click', function (e) {
    $(this).closest('.dropdown').find('[data-toggle="dropdown"]').dropdown('hide');
});


$('[data-spy="scroll"]').each(function () {
    var __target = $(this).data('target');
    console.log(__target);
    $(this).scrollspy({
        target: __target
    });
});

$('[data-spy="scroll"]').on('activate.bs.scrollspy', function () {
    console.log('__target');
})

$(document).on(
    'click',
    function (event) {
        var target = $(event.target);
        var _mobileMenuOpen = $(".navbar-collapse").hasClass("show");
        if (_mobileMenuOpen === true && !target.hasClass("navbar-toggler")) {
            $('#siteNavigation').collapse('hide');
        }
    }
);

$('a[smooth-scroll]').on('click', function (event) {
    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 140
    }, 500);
    event.preventDefault();
});



$('.select-picker').selectpicker({
    style: '',
    styleBase: 'form-control',
    width: 'auto'
});


$('.hero .list-has-popover .dropdown').on('mouseenter', function (e) {
    if (devicesWithPointer) {
        $(this).find('[data-toggle="dropdown"]').dropdown('show');
    }
}).on('mouseleave', function (e) {
    if (devicesWithPointer) {
        $(this).find('[data-toggle="dropdown"]').dropdown('hide').attr('aria-expanded', false);
    }
})


$('.hero-content__blocks .block-title').on('click', function (e) {
    if ($(this).hasClass('active')) {
        $('.block-title').removeClass('active');
        $('.hero-content__blocks .block-list').slideUp();
    } else {
        $('.block-title').removeClass('active');
        $(this).addClass('active');
        $('.hero-content__blocks .block-list').slideUp();
        $(this).parent().find('.block-list').slideDown();
    }
});


$(window).on('load', function () {

    var popularProductsCells = $('.popular-products .carousel-cell');
    var popularProductsCarousel = $('.popular-products .carousel');
    console.log(popularProductsCells);

    if (popularProductsCells.length > 3 || isTablet) {
        popularProductsSlider();
    } else {}

    function popularProductsSlider() {
        popularProductsCarousel.flickity({
            // options
            cellAlign: 'left',
            wrapAround: true,
            imagesLoaded: true,
            pageDots: false
        });
    }
})
if ($('.inspiration').length) {
    var $inspirationproductCarousel__main = $('.inspiration .product-variants__carousel');
    $inspirationproductCarousel__main.flickity({
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        adaptiveHeight: true,
        draggable: false
    });

    var $inspirationproductCarousel__nav = $('.inspiration .product-variants__carousel--nav');
    $inspirationproductCarousel__nav.flickity({
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        asNavFor: '.inspiration .product-variants__carousel',
        pageDots: false,
        draggable: false
    });

    $inspirationproductCarousel__nav.on('change.flickity', function (event, index) {
        $inspirationproductCarousel__main.flickity('select', index);
    });
}

if ($('.materials').length) {
    var $productvariantsCarousel__main = $('.materials .product-variants__carousel');
    $productvariantsCarousel__main.flickity({
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        adaptiveHeight: true,
        draggable: false
    });

    var $productvariantsCarousel__nav = $('.materials .product-variants__carousel--nav');
    $productvariantsCarousel__nav.flickity({
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        asNavFor: '.materials .product-variants__carousel',
        pageDots: false,
        draggable: false
    });

    $productvariantsCarousel__nav.on('change.flickity', function (event, index) {
        $productvariantsCarousel__main.flickity('select', index);
    });
}

var $productCarousel = $('.product-detail__showcase .carousel-init');
$productCarousel.flickity({
    cellAlign: 'left',
    wrapAround: true,
    imagesLoaded: true,
    autoPlay: 30000,
    pauseAutoPlayOnHover: true,
    pageDots: true,
    prevNextButtons: true,
    adaptiveHeight: true,
    watchCSS: true
});

$productCarousel.on('settle.flickity', function (event, index) {
    $productCarousel.flickity('playPlayer');
});

function productFeaturedVideo(e) {
    e.preventDefault();

    var __videoEl = $('#productFeaturedVideo');
    var __btnWithIcon = $('.collection-video .video-control');
    var __btnVideoCtaInline = $('.product-featured-video-cta');

    if (__videoEl.is('.paused')) {
        __videoEl.removeClass('paused').addClass('playing').trigger('play');
        __btnWithIcon.removeClass('paused').addClass('playing');
        __btnVideoCtaInline.text('Pause');
    } else {
        __videoEl.addClass('paused').removeClass('playing').trigger('pause');
        __btnWithIcon.addClass('paused').removeClass('playing');
        __btnVideoCtaInline.text('Play');
    }
}

$( ".flip-card__inner" ).on('click', function () {
    $(this).closest('.flip-card').toggleClass('active');
  });
// -------------------------------------------------------------------
// Media Queries
var isMobile = false;
var isTablet = false;
var devicesWithPointer = false;

mediaMobile();
mediaTouchDevices();

$(window).on('resize orientationchange', function () {
    mediaMobile();
    mediaTouchDevices();
});
// Media Query for mobile this will return true or false
function mediaMobile() {
    if (window.matchMedia('(max-width: 767px)').matches) {
        isMobile = true;
    } else {
        isMobile = false;
    }

    if (window.matchMedia('(max-width: 991px)').matches) {
        isTablet = true;
    } else {
        isTablet = false;
    }
}

// Media Query for Touch Devices this will return true or false
function mediaTouchDevices() {
    if (window.matchMedia('(any-hover: none)').matches) {
        devicesWithPointer = false;
    } else {
        devicesWithPointer = true;
    }
}


// Product Quantity
$(document).on('click', '.btn-number', function (e) {
    e.preventDefault();
    var qty_btn = $(this);
    updateInput(qty_btn);
});
function updateInput(qty_btn) {
    fieldName = qty_btn.attr('data-field');
    type = qty_btn.attr('data-type');
    var input = qty_btn.siblings("input[name='" + fieldName + "']");
    var currentVal = parseInt(input.val());
    if (!isNaN(currentVal)) {
        if (type == 'minus') {
            if (currentVal > input.attr('min')) {
                input.val(currentVal - 1).change();
            }
            if (parseInt(input.val()) == input.attr('min')) {
                qty_btn.attr('disabled', true);
            }
        } else if (type == 'plus') {
            if (currentVal < input.attr('max')) {
                input.val(currentVal + 1).change();
            }
            if (parseInt(input.val()) == input.attr('max')) {
                qty_btn.attr('disabled', true);
            }
        }
    } else {
        input.val(0);
    }
}
$('.input-number').on('focusin', function () {
    $(this).data('oldValue', $(this).val());
});
$('.input-number').on('change', function () {
    minValue = parseInt($(this).attr('min'));
    maxValue = parseInt($(this).attr('max'));
    valueCurrent = parseInt($(this).val());
    name = $(this).attr('name');
    if (valueCurrent >= minValue) {
        $(".btn-number[data-type='minus'][data-field='" + name + "']").removeAttr(
            'disabled')
    } else {
        alert('Sorry, the minimum value was reached');
        $(this).val($(this).data('oldValue'));
    }
    if (valueCurrent <= maxValue) {
        $(".btn-number[data-type='plus'][data-field='" + name + "']").removeAttr('disabled')
    } else {
        alert('Sorry, the maximum value was reached');
        $(this).val($(this).data('oldValue'));
    }
});
$(".input-number").on('keydown', function (e) {
    // Allow: backspace, delete, tab, escape, enter and .
    if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode == 65 && e.ctrlKey === true) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
        // let it happen, don't do anything
        return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode >
            105)) {
        e.preventDefault();
    }
});

// $('#modal--subscription').modal('show')
// $('#modal--subscription').on('shown', function (event) {
//     $('body').removeClass('.modal-open');
// })

// $('.toast').toast('show');